var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"join-box",attrs:{"tile":"","outlined":"","elevation":"0","min-height":"180"}},[_c('v-card-text',[(_vm.terms?.content)?_c('div',[_c('p',{staticClass:"textarea",attrs:{"name":"terms","readonly":""},domProps:{"innerHTML":_vm._s(_vm.terms?.content)}})]):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }